import React from "react";
import ListItem from "@material-ui/core/ListItem";
import ListItemText from "@material-ui/core/ListItemText";
import InputAdornment from "@material-ui/core/InputAdornment";
import TextField from "@material-ui/core/TextField";

import withStyles from "@material-ui/core/styles/withStyles";
import PropTypes from "prop-types";

const styles = () => ({
  listInput: {
    flexDirection: "column",
    alignItems: "flex-start"
  },
  fullWidth: {
    width: "100%"
  }
});

const CenterPhoneSettings = ({
  classes,
  settings,
  settingsDescription,
  handleInputChange,
  errorOnPhoneValidate
}) => (
  <ListItem disableGutters className={classes.listInput}>
    <ListItemText primary={settingsDescription.center.title} />
    <TextField
      className={classes.fullWidth}
      value={settings.center}
      onChange={handleInputChange("center")}
      margin="none"
      type="number"
      error={errorOnPhoneValidate(settings.center)}
      InputProps={{
        startAdornment: <InputAdornment position="start">+7</InputAdornment>
      }}
    />
  </ListItem>
);

CenterPhoneSettings.propTypes = {
  settings: PropTypes.object,
  settingsDescription: PropTypes.object,
  handleInputChange: PropTypes.func.isRequired,
  classes: PropTypes.object,
  errorOnPhoneValidate: PropTypes.func.isRequired
};

export default withStyles(styles)(CenterPhoneSettings);
